import { Report } from '../Components/index';

export default Report;
